import { createElement } from 'react';
import { Upload } from '@alifd/next';
import './index.scss';
const OadpUpload = function OadpUpload({ name, action, defaultValue, accept, method, reUpload, multiple, limit, timeout, shape, listType, disabled, dragable, useDataURL, ...otherProps }) {
    return (createElement(Upload, Object.assign({ name: name, action: action, defaultValue: defaultValue, accept: accept, multiple: multiple, timeout: timeout, method: method, limit: limit, reUpload: reUpload, shape: shape, listType: listType, disabled: disabled, dragable: dragable, useDataURL: useDataURL }, otherProps)));
};
export default OadpUpload;
